import React from "react";

export default function EvidenceHistoryModal({
  evidenceBoard,
  onClose,
  showTruth,
}) {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-cover bg-center w-full max-w-2xl h-[85vh] sm:h-[90vh] p-8 sm:p-12 shadow-2xl flex flex-col rounded-lg"
        style={{ backgroundImage: `url(/images/notebook_bg.jpg)` }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-4xl sm:text-5xl text-gray-800 font-bold mb-4 flex-shrink-0 font-handwriting text-center">
          Case Notes
        </h2>
        <div className="flex-grow overflow-y-auto pr-2 space-y-6">
          {(evidenceBoard || []).map((e) => {
            const allPastClues = [
              ...(e.trueClues || []),
              ...(e.fakeClues || []),
            ].sort((a, b) => a.clueId.localeCompare(b.clueId));
            return (
              <div
                key={e.round}
                className="border-b-2 border-dashed border-gray-400 pb-4"
              >
                <div className="mb-3">
                  <p className="font-handwriting font-bold text-2xl text-gray-700">
                    Round: {e.round}
                  </p>
                  <p className="font-handwriting text-lg text-red-700">
                    Victim(s): {e.victim}
                  </p>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  {allPastClues.map((clue, index) => {
                    let borderColor = "border-gray-400";
                    if (showTruth) {
                      borderColor = (e.trueClues || []).some(
                        (tc) => tc.clueId === clue.clueId
                      )
                        ? "border-green-600"
                        : "border-red-600";
                    }
                    const rotationClass = [
                      "-rotate-2",
                      "rotate-1",
                      "rotate-2",
                      "-rotate-1",
                      "rotate-3",
                      "-rotate-3",
                    ][index % 6];
                    return (
                      <div
                        key={clue.clueId}
                        className={`relative transform ${rotationClass}`}
                      >
                        <img
                          src="/images/tape.png"
                          alt="tape"
                          className="absolute -top-2 left-1/2 -translate-x-1/2 w-16 h-8 z-10 opacity-70"
                        />
                        <div
                          className={`bg-white p-1.5 rounded-sm shadow-md border-4 ${borderColor}`}
                        >
                          <img
                            src={clue.clueUrl}
                            alt={clue.clueName}
                            title={clue.clueName}
                            className="w-full aspect-square object-cover"
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <button
          onClick={onClose}
          className="mt-6 flex-shrink-0 bg-gray-700 hover:bg-gray-900 text-white font-bold py-3 px-4 rounded-lg mx-auto"
        >
          ปิดสมุดบันทึก
        </button>
      </div>
    </div>
  );
}
